<p class="select-label">{{ block().label }}</p>
<!-- role=group with aria-multiselectable tells assistive tech which mode this is (FR-044);
     each option is a real button, so it is reachable and operable by keyboard (FR-031). -->
<div class="select-options" role="group" [attr.aria-multiselectable]="isMulti()" [attr.aria-label]="block().label">
    @for (option of block().options; track option.value) {
        <button
            type="button"
            class="select-option"
            [class.select-option-on]="isSelected(option)"
            [attr.aria-pressed]="isSelected(option)"
            (click)="toggle(option)"
        >
            {{ option.label }}
        </button>
    }
</div>
<!-- FR-044: unavailable until the selection satisfies the mode. Disabled rather than hidden, so
     the reader can see what completing the selection will let them do. -->
<button type="button" class="select-submit" [disabled]="!canSubmit()" (click)="submit()">
    {{ block().submit.label }}
</button>
